export default interface DatatableColumnModel<T> {
    Field: string,
    Title: string,
    Align: DatatableColumnAlign,
    Width: string,
    AllowSort?: boolean,
    CellClassName?: string,
    CellHeaderClassName?: string,
    onCellClick?: (rowData: T) => void,
    Render: (rowData: T, index?: number) => JSX.Element,
}

export enum DatatableColumnAlign {
    Left,
    Center,
    Right
}